<template lang="html">
  <div :class="filterClass">
    <div class="filter__inner mx-4" v-if="item.type === 'range'">
      <div class="mb-2">{{ translateHeading(item.name) }}</div>
      <vue-slider
        v-model="activeFilter.val"
        :min="item.options[0]"
        :max="item.options[1]"
        :min-range="120"
        :interval="interval"
        :height="3"
        :dot-size="30"
        :enable-cross="false"
        tooltip="always"
        tooltip-dir="bottom"
        :tooltip-formatter="
          item.name == 'price' ? priceFormatter : mileageFormatter
        "
      >
        <template v-slot:process="{ start, end, style, index }">
          <div class="vue-slider-process" :style="style">
            <div
              v-show="showMergeTooltip"
              :class="`${
                showMergeTooltip
                  ? 'opacity-100 absolute top-7  left-1/2 transform -translate-x-1/2 -translate-y-0.5 whitespace-nowrap'
                  : 'opacity-0'
              }`"
            >
              {{ activeFilter.val[0] }}
              {{ item.name == 'price' ? ' NOK' : 'km' }}
              -
              {{ activeFilter.val[1] }}
              {{ item.name == 'price' ? ' NOK' : 'km' }}
            </div>
          </div>
        </template>
      </vue-slider>
    </div>

    <div class="filter__inner" v-if="item.type === 'select'">
      <div
        class="py-4 px-5 font-light text-grey-900 border border-grey-200 rounded bg-white dark:text-white dark:bg-grey-600 cursor-pointer relative"
        @click.self="handleFilterClick()"
      >
        <div class="flex gap-1 items-center">
          <div>{{ translateHeading(item.name) }}</div>

          <span v-if="activeFilter.val.length > 0">
            ({{ activeFilter.val.length }})
          </span>
        </div>
        <div
          class="flex items-center justify-center absolute w-7 h-7 right-2.5 top-1/2 -transform -translate-y-1/2"
          @click="handleFilterClear"
        >
          <IconClose v-if="activeFilter.val.length > 0" />
          <IconFeather v-else />
        </div>
      </div>
      <div :class="optionsClass" data-simplebar>
        <label
          class="py-3 px-4 flex items-center justify-between border border-grey-200 border-t-0 m-0 hover:bg-grey-200 dark:hover:bg-grey-500 transition-colors cursor-pointer"
          v-for="option in item.options"
          :key="option.name.split('.')[1]"
          :for="option.name.split('.')[1]"
        >
          <input
            type="checkbox"
            :id="option.name.split('.')[1]"
            :value="option.name.split('.')[1]"
            v-model="activeFilter.val"
          />
          <div class="check order-2">
            <IconCheck />
          </div>
          <div
            class="font-light text-base text-grey-600 dark:text-gold-50 p-2.5"
          >
            {{ translate(option.name) }}
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import IconCheck from './IconCheck.vue';
import IconFeather from './IconFeather.vue';
import IconClose from './IconClose.vue';

import VueSlider from 'vue-slider-component';
import { urlToObject } from '../helper/encoder';
export default {
  name: 'FilterItem',
  components: {
    VueSlider,
    IconCheck,
    IconFeather,
    IconClose,
  },
  props: ['item', 'filtersData'],
  data: function () {
    return {
      priceFormatter: (v) => `${this.$filters.formatNumber(v)} NOK`,
      mileageFormatter: (v) => `${this.$filters.formatNumber(v)} km`,
      isOpen: false,
      interval: 1,
      filterClass: `filter filter--${this.item.type} filter--${this.item.name}`,
      filterMaxRange: 0,
      activeFilter: {
        name: this.item.name,
        type: this.item.type,
        val: [],
      },
      optionsClass: 'options',
    };
  },
  mounted() {
    this.$nextTick(() => {
      const filters = urlToObject(window.location.href.split('?')[1]).f || [];
      let has_current_filter = false;
      if (filters.length > 0) {
        filters.map((filter) => {
          if (filter.name === this.item.name) {
            has_current_filter = true;
            this.activeFilter.val =
              this.item.type == 'range'
                ? filter.val.map((i) => parseInt(i))
                : filter.val;
          }
        });
      }

      if (!has_current_filter) {
        this.$nextTick(() => {
          if (this.item.type === 'range') {
            this.activeFilter.val = this.item.options;
          }
        });
      }
    });
  },
  computed: {
    showMergeTooltip() {
      if (this.item.type !== 'range') return;
      const dots = document.querySelectorAll(
        `.filter--${this.item.name} .vue-slider-dot-tooltip`
      );
      const cond =
        +this.activeFilter.val[1] - +this.activeFilter.val[0] <
        this.item.options[1] / 4;

      dots.forEach((el) => {
        el.classList[cond ? 'add' : 'remove']('opacity-0');
      });
      return cond;
    },
  },
  methods: {
    handleFilterClick() {
      this.isOpen = !this.isOpen;
    },
    handleFilterClear() {
      this.activeFilter.val = [];
    },
    translate(str) {
      const keyVal = str.split('.');

      const book = {
        drive: 'driveWheel',
        gearbox: 'transmission',
        models: 'model',
        brands: 'brand',
        mileage: 'mileage',
        fuel: 'fuel',
        location: 'location',
      };

      const group = this.filtersData.filter((obj) => {
        return obj.name === book[keyVal[0]];
      })[0];

      const option = group.options.filter((obj) => {
        return obj.name === str;
      })[0];

      return option.translation || option.value;
    },
    translateHeading(str) {
      const book = {
        brand: 'Velg merke',
        model: 'Velg modell',
        transmission: 'Velg girkasse',
        fuel: 'Velg drivstoff',
        driveWheel: 'Velg hjuldrift',
        price: 'Filtrer etter pris',
        mileage: 'Filtrer etter kilometerstand',
        location: 'Velg avdeling',
      };

      return book[str] || str;
    },
  },

  watch: {
    activeFilter: {
      handler: function (newValue) {
        this.$emit('filtersUpdated', newValue);
      },
      deep: true,
    },
  },
};
</script>
